import * as PleasedApi from '@/common/api/api.pleased';
import { ArticleMetrics } from '@/common/api/models.pleased';
import { ActionContext, MutationTree } from 'vuex';

const state: ArticleMetricsState = {
  articleId: '',
  duration: 0,
  abValue: '',
  connectToAgent: false,

  userAbValue: '',
  userId: '',
};

interface ArticleMetricsState {
  articleId: string;
  duration: number;
  abValue: string;
  connectToAgent: boolean;

  userAbValue: string;
  userId: string;
}

const mutations: MutationTree<ArticleMetricsState> = {
  setArticleMetrics(state, metrics: ArticleMetrics) {
    state.articleId = metrics.articleId;
    state.duration = metrics.duration;
    state.abValue = metrics.abValue;
    state.connectToAgent = metrics.connectToAgent;
  },
};

const actions = {
  async saveArticleMetrics(
    { rootState }: ActionContext<ArticleMetricsState, any>,
    args: { endChat?: boolean; restartChat?: boolean } = {}
  ) {
    const country = rootState['user'].country;
    const pleasedUser = rootState['user'].pleasedUser;
    const userId = pleasedUser?.userId;

    const { endChat, restartChat } = args || {};

    if (state.articleId === '' || state.duration === 0) {
      return;
    }

    await PleasedApi.trackArticle({
      articleId: state.articleId,
      duration: state.duration,
      abValue: state.abValue,
      connectToAgent: state.connectToAgent,
      country,
      userId,
      endChat,
      restartChat,
    });
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
